var map = {
	"./MW_Telegram_Instruction_1.gif": "4f0f",
	"./MW_Telegram_Instruction_2.gif": "c1ed",
	"./MW_Telegram_Instruction_3.gif": "f7a2",
	"./MW_Telegram_Instruction_4.gif": "ed29"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "953d";